import { forwardRef } from 'react';
import * as Radix from '@radix-ui/react-tabs';
import { cn } from '../lib/cn';

export const Tabs = Radix.Root;

export const TabsList = forwardRef<
  React.ElementRef<typeof Radix.List>,
  React.ComponentPropsWithoutRef<typeof Radix.List>
>(function TabsList({ className, ...rest }, ref) {
  return (
    <Radix.List
      ref={ref}
      className={cn(
        'flex items-center gap-1 border-b border-border-soft',
        className,
      )}
      {...rest}
    />
  );
});

export const TabsTrigger = forwardRef<
  React.ElementRef<typeof Radix.Trigger>,
  React.ComponentPropsWithoutRef<typeof Radix.Trigger>
>(function TabsTrigger({ className, ...rest }, ref) {
  return (
    <Radix.Trigger
      ref={ref}
      className={cn(
        'relative inline-flex items-center gap-2 px-3 py-2.5 text-base font-medium',
        'text-ink-secondary transition-colors duration-fast ease-enter',
        'hover:text-ink',
        'data-[state=active]:text-ink',
        'data-[state=active]:after:absolute data-[state=active]:after:inset-x-0 data-[state=active]:after:-bottom-px data-[state=active]:after:h-[2px] data-[state=active]:after:bg-primary data-[state=active]:after:rounded-full',
        'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-soft rounded-sm',
        'disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
      {...rest}
    />
  );
});

export const TabsContent = forwardRef<
  React.ElementRef<typeof Radix.Content>,
  React.ComponentPropsWithoutRef<typeof Radix.Content>
>(function TabsContent({ className, ...rest }, ref) {
  return (
    <Radix.Content
      ref={ref}
      className={cn(
        'pt-5 focus-visible:outline-none',
        'data-[state=active]:animate-fade-in',
        className,
      )}
      {...rest}
    />
  );
});
